module.exports = __webpack_public_path__ + "static/img/190725-egg-fish.1997a02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190725-egg-fish.jpg
// module id = 9bTc
// module chunks = 0